"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DAYS_BEFORE_DUE_DATE = exports.DeliverableContainerTypes = exports.DeliverableTypes = exports.v3DEPRECATED = exports.v2DEPRECATED = void 0;
var v2DEPRECATED;
(function (v2DEPRECATED) {
    let StatusEnum;
    (function (StatusEnum) {
        StatusEnum["NotStarted"] = "notStarted";
        StatusEnum["Upcomint"] = "upcoming";
        StatusEnum["DueSoon"] = "dueSoon";
        StatusEnum["Overdue"] = "overdue";
        StatusEnum["Expired"] = "expired";
        StatusEnum["Completed"] = "completed";
        StatusEnum["Waived"] = "waived";
    })(StatusEnum = v2DEPRECATED.StatusEnum || (v2DEPRECATED.StatusEnum = {}));
    let DueDateStatus;
    (function (DueDateStatus) {
        DueDateStatus["Upcoming"] = "upcoming";
        DueDateStatus["DueSoon"] = "dueSoon";
        DueDateStatus["Overdue"] = "overdue";
        DueDateStatus["Expired"] = "expired";
    })(DueDateStatus = v2DEPRECATED.DueDateStatus || (v2DEPRECATED.DueDateStatus = {}));
})(v2DEPRECATED = exports.v2DEPRECATED || (exports.v2DEPRECATED = {}));
var v3DEPRECATED;
(function (v3DEPRECATED) {
    let DeliverableType;
    (function (DeliverableType) {
        DeliverableType["BackupServicerReport"] = "backupServicerReport";
        DeliverableType["BackupServicingPlan"] = "backupServicingPlan";
        DeliverableType["BankStatement"] = "bankStatement";
        DeliverableType["BorrowingBaseCertificate"] = "borrowingBaseCertificate";
        DeliverableType["BorrowingBaseReport"] = "borrowingBaseReport";
        DeliverableType["Budget"] = "budget";
        DeliverableType["CollateralAndServicingReport"] = "collateralAndServicingReport";
        DeliverableType["CollateralVerification"] = "collateralVerification";
        DeliverableType["ComplianceCertificate"] = "complianceCertificate";
        DeliverableType["ComplianceStatement"] = "complianceStatement";
        DeliverableType["FinancialStatement"] = "financialStatement";
        DeliverableType["LoanTape"] = "loanTape";
        DeliverableType["ManagementReport"] = "managementReport";
        DeliverableType["OfficersCertificate"] = "officersCertificate";
        DeliverableType["Other"] = "other";
        DeliverableType["PerformanceReport"] = "performanceReport";
        DeliverableType["Projections"] = "projections";
        DeliverableType["RemittanceDate"] = "remittanceDate";
        DeliverableType["RemittanceReport"] = "remittanceReport";
        DeliverableType["ServicerReport"] = "servicerReport";
        DeliverableType["SettlementReport"] = "settlementReport";
    })(DeliverableType = v3DEPRECATED.DeliverableType || (v3DEPRECATED.DeliverableType = {}));
    v3DEPRECATED.DeliverableValueTypes = [
        'noSubmission',
        'file',
        'string',
        'number',
        'boolean',
    ];
    v3DEPRECATED.DeliverableFileTypes = [
        'csv',
        'docx',
        'doc',
        'pdf',
        'xlsx',
        'xls',
        'txt',
        'zip',
        'png',
        'jpg', // jpg + jpeg have the same mime type
    ];
    v3DEPRECATED.PremissionTypes = ['download', 'view'];
    v3DEPRECATED.ProgressStatuses = [
        'notSubmitted',
        'submitted',
        'resubmit',
        'waived',
    ];
})(v3DEPRECATED = exports.v3DEPRECATED || (exports.v3DEPRECATED = {}));
// ___________ CONFIG TYPES ___________
exports.DeliverableTypes = [
    'monthlyServicerReportXlsx',
    'loanTape',
    'repaymentTape',
    'supplementalTape',
    'cashBalancesFeed',
    'portfolioCovenant',
    'orgProvidedInput',
    'monthlyStatement',
    // 'financialStatement', domain isn't supported yet, punting on this config
];
exports.DeliverableContainerTypes = [
    'settlementReport',
    'borrowingBaseCertificate',
    'complianceCertificate',
    'financials',
    'budgetsAndProjections',
    'other', // domain isn't supported yet
];
exports.DAYS_BEFORE_DUE_DATE = 30;
//# sourceMappingURL=Deliverable.js.map